import React, { useContext } from 'react';
import { ReportItem } from '../MenuItem';
import {
    DownloadReportsModel,
    EmployeeNodeModel,
    LanguageModel,
} from '../../../../../models';
import { toast } from 'react-toastify';
import { getEmployeesIds } from '../../../../../utils';
import { AppContext } from '../../../../context';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';
import { start } from 'repl';

interface Props {
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

const OperationCenterMenuGroup: React.FC<Props> = ({
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}) => {
    const { langResources, downloadReport } = useContext(AppContext);

    /**
     * Descarga el reporte de Historial de Solicitudes por Autorizador
     */
    const handlerSaveReportOperationsCenter = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Programación Centro Operación',
            '/jerusalem/api/v2.0.0/reports/operations-center-scheduling',
            downloadReport
        );
    };

    const menuItems = [
        {
            label: 'Programación Centro Operación',
            handler: handlerSaveReportOperationsCenter,
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>Centros de operación</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-4'>
                    {menuItems.map(({ label, handler }, index) => (
                        <ReportItem key={index} label={label} handler={handler} />
                    ))}
                </ul>
            </div>
        </li>
    );
};

export default OperationCenterMenuGroup;
